import {
  FilterFieldContainer,
  FilterInput,
  FilterLabel,
} from '../GeneratikTableFilterPanel.styles';
import { TextFieldProps } from '../GeneratikTableFilterPanel.types';

const TextFilterField = ({ field, value, onChange, t, disabled }: TextFieldProps) => (
  <FilterFieldContainer data-testid={`filter-field-${field.id}`}>
    <FilterLabel>{field.label}</FilterLabel>
    <FilterInput
      type="text"
      placeholder={field.placeholder || t('Enter value...')}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
    />
  </FilterFieldContainer>
);

export default TextFilterField;
